import { Ship, Linkedin, Facebook, Instagram, Twitter, Phone, MapPin } from 'lucide-react';

export function LandingFooter() {
  return (
    <footer
      className="px-4 py-16 text-slate-300"
      style={{ backgroundColor: '#0f172a' }}
    >
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center space-x-2 text-white">
            <img src="/images/logo-missi.png" alt="Missi Track" width={36} height={36} className="h-9 w-auto object-contain" />
          </div>
          <p className="mt-5 max-w-md text-sm text-slate-400">
            Leading provider of innovative electronic solutions in tracking, communication, navigation
            and trading for the maritime industry.
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <div className="flex space-x-2">
              {[
                { Icon: Linkedin, label: 'LinkedIn' },
                { Icon: Facebook, label: 'Facebook' },
                { Icon: Instagram, label: 'Instagram' },
                { Icon: Twitter, label: 'Twitter' },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="grid h-9 w-9 place-items-center rounded-md border border-slate-800 transition hover:bg-brand-500 hover:border-brand-500"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
            <a
              href="https://play.google.com/store/apps/details?id=com.missi.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 rounded-lg border border-slate-700 bg-slate-900 px-3.5 py-2 text-white transition hover:border-brand-500 hover:bg-slate-800"
            >
              <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#4285F4" d="M3.61 1.814L13.793 12 3.61 22.186a1.75 1.75 0 01-.473-1.206V3.02c0-.465.174-.895.473-1.206z" />
                <path fill="#34A853" d="M17.218 8.575L13.793 12 3.61 1.814c.385-.401.988-.52 1.547-.202l12.061 6.963z" />
                <path fill="#FBBC05" d="M20.892 10.696c.875.505.875 2.103 0 2.608l-3.674 2.121L13.793 12l3.425-3.425 3.674 2.121z" />
                <path fill="#EA4335" d="M17.218 15.425L5.157 22.388c-.559.318-1.162.199-1.547-.202L13.793 12l3.425 3.425z" />
              </svg>
              <div className="flex flex-col items-start leading-none text-left">
                <span className="text-[9px] font-medium uppercase tracking-wider text-slate-400">Get it on</span>
                <span className="text-xs font-bold tracking-tight text-white mt-0.5">Google Play</span>
              </div>
            </a>
          </div>
        </div>

        <div>
          <h5 className="font-semibold text-white">Contact</h5>
          <p className="mt-4 flex items-start space-x-2 text-sm">
            <Phone className="mt-0.5 h-4 w-4 text-brand-500" />
            <span>
              Phone: 021 2787 4648
              <br />
              Sales: +62 813-8260-9869
              <br />
              Email: support@mitos.id
            </span>
          </p>
        </div>

        <div>
          <h5 className="font-semibold text-white">Address</h5>
          <p className="mt-4 flex items-start space-x-2 text-sm text-slate-400">
            <MapPin className="mt-0.5 h-4 w-4 text-brand-500" />
            <span>Perkantoran Tanjung Mas Raya, blok B1 nomor 44, RT.002/RW.001. Tanjung Barat, Jagakarsa, Jakarta Selatan.</span>
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-slate-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <p>© 2026 Missi Track. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <a href="/terms" className="hover:text-slate-300 transition-colors">
            Terms & Conditions
          </a>
          <a href="/privacy" className="hover:text-slate-300 transition-colors">
            Privacy Policy
          </a>
          <a href="/contact" className="hover:text-slate-300 transition-colors">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}

